import React, { useState } from "react";
import DatePicker from "@otrl/ui/components/date/DatePicker";

import { noop } from "lib/utils";
import { TimeTypes } from "models/DateTime";
import useOuterClick from "hooks/useOuterClick";
import TimeInput from "components/ui/TimeInput";
import Button from "components/ui/Button";
import "styles/components/date-popup.scss";

const DatePopup = ({
  dateTime,
  onChange = noop,
  onHide = noop,
  isReturn = false,
  isSeason = false,
  isOther = false,
  maxDate,
  minDate,
}) => {
  const refOuterClick = useOuterClick(onHide);

  const [selectedDate, selectDate] = useState(dateTime.toDate());

  const handleDate = date => {
    onChange({ date });
    selectDate(date);
  };

  const handleTime = time => {
    if (time === TimeTypes.DEPART_NOW) {
      onChange({ timeType: TimeTypes.DEPART_NOW });
    } else {
      onChange({ time });
    }
  };

  const handleTimeType = timeType => {
    onChange({ timeType });
  };

  const handleClick = e => {
    e.stopPropagation(); // prevents an outer click that would close this popup
  };

  return (
    <div className="otrl-jp__date-popup" onClick={handleClick} ref={refOuterClick}>
      <div className="otrl-jp__date-popup__calendar">
        <DatePicker
          formatTitle="MMMM yyyy"
          numberOfMonths={2}
          onChange={handleDate}
          selected={dateTime.toDate()}
          maxDate={maxDate}
          minDate={minDate}
        />
      </div>
      <div className="otrl-jp__date-popup__action-row">
        {!isSeason && !isOther && (
          <TimeInput
            dateTime={dateTime}
            selectedDate={selectedDate}
            onTimeChange={handleTime}
            onTimeTypeChange={handleTimeType}
            isReturn={isReturn}
          />
        )}
        <Button className="otrl-jp__date-popup__button" text="Done" onClick={onHide} />
      </div>
    </div>
  );
};

export default DatePopup;
